import React from 'react';
import { ListOrderedIcon, RotateCcwIcon } from 'lucide-react';
interface RankingInstructionProps {
  onClear: () => void;
  hasSelections: boolean;
}
export function RankingInstruction({
  onClear,
  hasSelections
}: RankingInstructionProps) {
  return <div className="flex items-center justify-between mb-6 bg-slate-50 border border-slate-200 rounded-lg p-3" data-id="element-53">
      <div className="flex items-center gap-2 text-slate-600" data-id="element-54">
        <ListOrderedIcon className="w-4 h-4" data-id="element-55" />
        <span className="text-sm font-medium" data-id="element-56">
          Click cards in order of priority (1 = highest)
        </span>
      </div>
      {hasSelections && <button onClick={onClear} className="flex items-center gap-1.5 text-sm font-medium text-slate-500 hover:text-minerva transition-colors" data-id="element-57">
          <RotateCcwIcon className="w-3.5 h-3.5" data-id="element-58" />
          Clear ranking
        </button>}
    </div>;
}